import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"care_mask_title"} defaultMessage={"Cuidado com o uso da máscara"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"care_mask_text_1"} defaultMessage={"Remova a máscara usando a técnica apropriada: não toque na frente da máscara, desamarre-a na parte de trás."}/></li>
                    <li>• <FormattedMessage id={"care_mask_text_2"} defaultMessage={"Após a remoção ou sempre que uma máscara for tocada inadvertidamente, limpe as mãos usando álcool gel ou sabão e água, se as mãos estiverem visivelmente sujas."}/></li>
                </ul>
                <p><b><FormattedMessage id={"care_mask_text_3"} defaultMessage={"Como eu devo remover a máscara?"}/></b></p>
                <ol>
                    <li><FormattedMessage id={"care_mask_text_4"} defaultMessage={"Lave suas mãos: lave suas mãos antes de tocar a máscara."}/></li>
                    <li><FormattedMessage id={"care_mask_text_5"} defaultMessage={"Como eu devo remover a máscara? Remova a máscara segurando os elásticos/amarras, sem tocar a frente da máscara já que ela pode estar contaminada."}/></li>
                    <li><FormattedMessage id={"care_mask_text_6"} defaultMessage={"Lave suas mãos novamente: lave suas mãos depois de remover a máscara."}/></li>
                    <li><FormattedMessage id={"care_mask_text_7"} defaultMessage={"Lave a máscara: coloque-a para lavar o quanto antes."}/></li>
                    <li><FormattedMessage id={"care_mask_text_8"} defaultMessage={"Guarde a máscara: caso você não possa lavar no momento, guarde-a em um saco fechado."}/></li>
                </ol>
            </div>
            <div align="center">
                <a href={"/masks"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;